<!-- panneau gauche -->
<wiz-h-divider width="100%" height="100%" gap="0">
  <wiz-vgroup gap="0" width="450px" height="100%" #gListContainer>
    <multi-display #multiDisp height="100%" [config]="multiDisplayConfig">
      <wiz-hgroup target="icons">
        <wiz-icon #btnExport [wizTooltip]="'$.common.export.$'" class="image-purple"
          (click)="doAct('export')">download</wiz-icon>
        <wiz-icon #btnImport [wizTooltip]="'$.common.import.$'" class="image-purple"
          (click)="doAct('import')">upload</wiz-icon>
        <wiz-icon #btnRemove class="image-purple" [wizTooltip]="'$.common.delete.$'"
          (click)="doAct('delete')">delete</wiz-icon>
      </wiz-hgroup>

      <!-- bouton d'ajout -->
      <wiz-vgroup target="title">
        <wiz-hgroup verticalAlign="center" gap="10">
          <wiz-icon #btCreateChronocode #btnCreate [wizTooltip]="'$.chronocode.create.$'" tooltipPlacement="right"
            class="image-back-orange" (click)="doAct('create')">add</wiz-icon>
          <wiz-label class="titleLabel" [wizLabel]="'$.chronocode.create.$'" [wizTextBehavior]="'truncate'"
            width="100%"></wiz-label>
        </wiz-hgroup>
        <wiz-button class="hyperButton" [wizLabel]="'$.common.create.from.model.$'"></wiz-button>
      </wiz-vgroup>
    </multi-display>
  </wiz-vgroup>
  <!-- chargeur de sous-vues : chronoHome chronoCreation chronoUpdate -->
  <wiz-group width="100%" height="100%" gap="0" minWidth="600px">
    <router-outlet></router-outlet>
  </wiz-group>
</wiz-h-divider>